angular.module('rjmNg.common.api').factory "Users", [
  "$resource"
  "sharedCaches"
  "serviceUrl"
  (
    $resource
    sharedCaches
    serviceUrl
  ) ->

    defaultParams =
      withCredentials: true
      headers:
        Accept: 'application/json'
        'Content-Type': 'application/json'

    isSuccess = (status) ->
      return 200 <= status && status < 300

    postProcessUserInfo = (data, headersGetter, status) ->
      try
        userInfo = angular.fromJson(data)
      catch error
        return data

      # Since users which already existed before color themes don't have info in db we need to specify it here
      if isSuccess(status) and not userInfo.properties.color_theme_id?
        userInfo.properties.color_theme_id = "0"

      return userInfo

    actions =
      delete: angular.extend {}, defaultParams,
        method: "DELETE"
      get: angular.extend {}, defaultParams,
        method: "GET"
        transformResponse: postProcessUserInfo
      query: angular.extend {}, defaultParams,
        isArray: true
        method: "GET"
      save: angular.extend {}, defaultParams,
        method: "PUT"
      updatePassword: angular.extend {}, defaultParams,
        method: "PUT"
        url: serviceUrl("/users/:id/password")
      updateProperties: angular.extend {}, defaultParams,
        method: "PUT"
        url: serviceUrl("/users/:id/properties")

    resource = $resource(serviceUrl("/users/:id"), {}, actions)

    {
      delete: (id, clientId) ->
        unless clientId?
          throw new Error("When DELETING a user, the client id must be specified.")
        resource.delete({id, client_id: clientId}).$promise

      get: (id) ->
        resource.get({id}).$promise

      query: (clientId) ->
        unless clientId?
          throw new Error("When querying users, the client id must be specified.")
        resource.query({client_id: clientId}).$promise

      save: (user) ->
        resource.save({id: user.id}, user).$promise

      updateProperties: (id, propertiesMap) ->
        resource.updateProperties({id}, propertiesMap).$promise

      updatePassword: (id, oldPassword, newPassword) ->
        data = {
          oldPassword
          newPassword
          termsOfService: true
        }
        resource.updatePassword({id}, data).$promise

      resetPassword: (id, resetToken, newPassword) ->
        data = {
          reset_token: resetToken
          newPassword
          termsOfService: true
        }
        resource.updatePassword({id}, data).$promise

    }
]
